export const COMPANY_ID = '2941';
export const BASE_URL = '//cdn.powerinboxedge.com/framework/pi-notify.js';
